import styled from "styled-components";

export const StaffPopupWrapper = styled.div`
  position: absolute;
  background-color: white;
  border-radius: 13px;
  display: flex;
  flex-direction: row;
  width: 880px;
  height: 366px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 40px 15px 23.5px;
  box-sizing: border-box;
`;

export const StaffTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StaffPopupLeft = styled.div`
  flex: 1;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > .header {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const StaffSearchInput = styled.input`
  width: 380px;
  height: 10px;
  padding: 10px 15px;
  align-items: center;
  border-radius: 15px;
  border: 1px solid #e5e5e5;

  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StaffSearchButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const StaffSearchButton = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 48px;
  border-radius: 8px;
  background: ${(props) => (props.isSelected ? "#6436e7" : "#fff")};

  color: ${(props) => (props.isSelected ? "#fff" : "#6436e7")};
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;

  cursor: pointer;
  &:hover {
    background: ${(props) => (props.isSelected ? "#5227c2" : "#f5f5f5")};
  }
`;

export const StaffPopupRight = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StaffList = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
`;

export const StaffItem = styled.div`
  width: calc(100% - 30px);
  height: 25px;
  border-radius: 15px;
  background: #ecf0f3;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  > .item {
    flex: 1;

    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .delete {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 15px;
  }
`;
